//lib
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function ImgRender({ item, index }) {
  return <LazyLoadImage key={index} src={item.url} alt="reunion-post"/>;
}
 